/**
 * Manage application API promise caching init and reset.
 * 
 * @see
 * @author Carmen Totino(Fresche Solutions)
 * @date June 2025
 */

const apiPromiseCache = new Map();

export function getCachedApiCall(filterType, apiCall) {
  if (!apiPromiseCache.has(filterType)) {
    const promise = apiCall().then(result => {
      apiPromiseCache.set(filterType, Promise.resolve(result)); // store resolved result
      return result;
    });
    apiPromiseCache.set(filterType, promise);
  }

  return apiPromiseCache.get(filterType);
}

export function clearApiCache(filterType) {
  if (filterType) {
    apiPromiseCache.delete(filterType);
  } else {
    apiPromiseCache.clear(); // clear all
  }
}